import React, { useEffect, useState } from "react";
import { Button, Card, DatePicker, Input, Select, Skeleton, Spin } from "antd";
// import {
//   useGetFlowSectionMasterDataQuery,
//   useGetFlowConverterDetailsQuery,  jjhbhipjipi
//   useGetFlowSteamGropeMeterDetailsQuery,
//   useGetsteamMeterStatusDetailsQuery,
//   useNSGetFlowConverterDetailsQuery,
// } from "../../../../services/steam/LiveModule/LiveTrendsAPI";

// import { useGetFlowGroupDetailsQuery } from "../../../../services/config_layout/group";
  
// import errorNew from "../../../../assets/error/error.png";   


import CustomDrawer from "../../../../../../Elements/CustomDrawer";
import CustomSelect from "../../../../../../Elements/CustomSelect";
import SteamTreeSelectCustomWithSelectAll from "../../../../../../Elements/TreeSelect/TreeSelectCustomWithSelectAll";
import { useStoreUpdaterWithAPI } from "../../../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../../../Common/APIConstants";
import MeterGrid from "../../../../../../Elements/Grid/MeterGrid";
import { calculateDateRangeFromDate } from "../../../../../../../Utils/DateConverstion";
import { useSelector } from "react-redux";
   


const { Option } = Select;  
const { RangePicker } = DatePicker;

const TempMeterStatus = () => {

  const { makeRequest } = useStoreUpdaterWithAPI();
  const [open, setOpen] = useState(false);
  const [sectionId, setSectionId] = useState(null);
  const [converterGroupId, setConverterGroupId] = useState(null);
  const [report, setReport] = useState(null);
  const [skip, setSkip] = useState(true); 
  const [selectedMeterIds, setSelectedMeterIds] = useState([]);
  const [sectionError, setSectionError] = useState();
  const [converterError, setConverterError] = useState();
  const [meterError, setMeterError] = useState();
  const [isLoading, setIsLoading] = useState(false)
  const [submitClicked, setSubmitClicked] = useState(false);
  const [input, setInput] = useState(null);
  const [flowSectionList, setFlowSectionList] = useState([])
  const [flowConverterList, setFlowConverterList] = useState([])
  const [flowGroupDetailList, setFlowGroupDetailList] = useState([])
  const [nsFlowConverterList, setNsFlowConverterList] = useState([]);
  const [steamGroupMeterList, setSteamGroupMeterList] = useState([]);
  const [steamMeterData, setSteamMeterData] = useState([]);
  const [loading, setLoading] = useState(true);
  const simulateLoading = (setLoading) => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000); // 2 seconds
  };

  useEffect(()=>{
    simulateLoading(setLoading); 
  },[])

  const showDrawer = () => {
    setOpen(true);
  }; 
  const onClose = () => {
    setOpen(false);
  };

  const dummyResponse = [
    {
        "sitE_ID": 9,
        "workstation": "SalComp",
        "sitename": "S9",
        "comport": "com4",
        "baudrate": "4200",
        "databits": "",
        "parity": "none",
        "stopbit": "1",
        "delete_yn": 1,
        "siteIP": "192.168.0.14",
        "port": "4001",
        "noofPorts": 1,
        "electricityModule": 0,
        "steamModule": 0,
        "waterModule": 0,
        "airModule": 0,
        "gasModule": 0,
        "temperatureModule": 0
    },
    {
        "sitE_ID": 10,
        "workstation": "SalComp",
        "sitename": "S10",
        "comport": "com4",
        "baudrate": "4200",
        "databits": "",
        "parity": "none",
        "stopbit": "1",
        "delete_yn": 1,
        "siteIP": "192.168.0.12",
        "port": "4001",
        "noofPorts": 1,
        "electricityModule": 0,
        "steamModule": 0,
        "waterModule": 0,
        "airModule": 0,
        "gasModule": 0,
        "temperatureModule": 0
    }
]


  const fetchSteamMeterLive = (input) => {
    const url = `${APIConstants.GET_METER_STATUS_TEMPERATURE}?SectionID=${input.SectionID}&ConverterorGroupID=${input.ConverterorGroupID}&MeterIds=${input.MeterIds}&FromDate=${input.FromDate}&Todate=${input.ToDate}`;
    console.log(url);

    makeRequest({
      type: APIConstants.GET,
      url: url,
    }).then((res) => {
      setIsLoading(false)
      setSteamMeterData(res);
      console.log(res);
    });
  };



  useEffect(() => {
    if (input) {
      fetchSteamMeterLive(input);
    }
  }, [input]);

//to fetch meter upon converter selection  
const fetchNsFlow= (id) => {
  makeRequest({
    type: APIConstants.GET,
    url: `${APIConstants.TEMP_METERS_LIST}?SiteID=${id}`
    // url: `${APIConstants.GET_FLOW_NS_CONVERTER_DETAILS}?ConverterID=${id}`
  }).then((res) => {
    console.log(res)
    if (res.length > 0) {
      setNsFlowConverterList(res);
    }
    // setNsFlowConverterList(res);
  });
};


useEffect(() => {
  if (converterGroupId) {
    fetchNsFlow(converterGroupId);
  }
}, [converterGroupId]); 



//to fetch metrs upon group selection
const fetchGroupMeter= (id) => {
 
  makeRequest({
    type: APIConstants.GET,
    // GetFlowSteamGropeMeterDetails?GroupID=81
    url: `${APIConstants.GET_FLOW_STEAM_GROUP_METER_DETAILS}?GroupID=${id}`
  }).then((res) => {
    console.log(res)
    setSteamGroupMeterList(res);
  });
};


useEffect(() => {
  if (converterGroupId) {
    fetchGroupMeter(converterGroupId);
  }
}, [converterGroupId]);


useEffect(()=>{
  makeRequest({
    type: APIConstants.GET,
    url: APIConstants.GET_FLOW_SECTION_MASTER_DETAILS,
  }).then((res) => {
      console.log(res)
    setFlowSectionList(res); 
  });

  makeRequest({
    type: APIConstants.GET,

    url: APIConstants.TEMP_GETSITES,
  }).then((res) => {
    console.log(res)
    // console.log(dummyResponse)
    setFlowConverterList(res);
    // setFlowConverterList(dummyResponse);
  });

  makeRequest({
    type: APIConstants.GET,

    url: APIConstants.GET_STEAM_FLOW_GROUP_DETAILS,
  }).then((res) => {
    console.log(res)
    setFlowGroupDetailList(res);
  });

},[])

 
  const inputData = { 
    SectionID:  1,
    ConverterorGroupID: 1,
    MeterIds:  "1",
    FromDate:  "2023-09-21T07:15:00.000Z",
    ToDate:  "2023-09-25T07:15:00.000Z",
  }

  
  const handleChangeSection = (changedValues) => {
    setReport([])
    setSectionId(changedValues);
    setSelectedMeterIds();
    setConverterGroupId(null);
    setSubmitClicked(false)
    if (changedValues) {
      setSectionError("");
    }
  };

  useEffect(() => {
    // After 1 second, set skipValue to false
    const timeoutId = setTimeout(() => {
      setSkip(false);
    }, 3000);

    // // Clear the timeout if the component unmounts or skipValue is set to false jbjh nbbvjkghk khi7t llknnnkjnjknjn bnl kjih  jjnjnj jnkjj    ml     cx  xcvcv 
    return () => clearTimeout(timeoutId);
  }, []);
 

  const handleChangeConverterGroup = (changedValues) => {
    setReport([])
    setConverterGroupId(changedValues);
    setSubmitClicked(false)
    setSelectedMeterIds();
    if (changedValues) {
      setConverterError("");
    }
  };

  const handleMeterChange = (selectedValues) => {
    setSelectedMeterIds(selectedValues);
    if(!selectedValues.length){
      setSubmitClicked(false)
    }
    if (selectedValues) {
      setMeterError("");
    }
  };  

  const setInputData = () => {
    const ids = selectedMeterIds?.map((id) => id).join(",");
    const currentDate = new Date();
    const { from, to } = calculateDateRangeFromDate(currentDate, 5, 1);

    const inputData = {
      SectionID: Number(sectionId),
      ConverterorGroupID: Number(converterGroupId) ,
      MeterIds: ids,
      FromDate:  from,
      ToDate:  to,
    };

    const queryString = (inputData);
    setInput(queryString);
  };

  const validateInput = (value, label) => {
    const error = !value ? `Please Select ${label}` : "";
    return error;
  };
  
  const handleSubmit = async () => {

    setSubmitClicked(true)
    const sectionError = validateInput(sectionId, "Section");
    const converterError = validateInput(converterGroupId, "Converter");
    const meterError = validateInput(selectedMeterIds?.length, "Meter");

    setSectionError(sectionError);
    setConverterError(converterError);
    setMeterError(meterError);

    if (!sectionError && !converterError && !meterError ) {
      setInputData();
      setIsLoading(false)
      onClose()
    }
  };

  useEffect(() => {
  if (steamMeterData?.length) {
      const selectedMeterData = steamMeterData?.filter((item) =>
        selectedMeterIds?.map((id) => Number(id)).includes(item.meterid)
      );
      setIsLoading(false)
      setReport(selectedMeterData);
    }
  }, [steamMeterData]);

  useEffect(() => {
    const timer = setInterval(() => {
      if (submitClicked && converterGroupId && sectionId && selectedMeterIds?.length ) {
        setInputData();
      }
    },500000)
    return () => clearInterval(timer);
  },[converterGroupId, sectionId, selectedMeterIds, submitClicked])


  console.log(report)

  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;
  console.log(isdarkMode)


  const reports = [
    {
        "sitename": "S9",
        "meterid": 68,
        "metername": "ORT  Lab Temperature 2\r\n",
        "rh": 55.2,
        "temperature": 23.7,
        "createdON": "2024-10-21T14:53:51.063",
        "meterStatus": "NO"
    },
    {
        "sitename": "S9",
        "meterid": 67,
        "metername": "ORT  Lab Temperature 1\r\n",
        "rh": 49.9,
        "temperature": 25.4,
        "createdON": "2024-10-21T14:53:50.017",
        "meterStatus": "NO"
    },
    {
        "sitename": "S9",
        "meterid": 64,
        "metername": "Coil Area Temperature 5\r\n",
        "rh": 44.1,
        "temperature": 28.8,
        "createdON": "2024-10-21T14:53:48.997",
        "meterStatus": "NO"
    },
    {
        "sitename": "S9",
        "meterid": 63,
        "metername": "Coil Area Temperature 4\r\n",
        "rh": 41.5,
        "temperature": 28.9,
        "createdON": "2024-10-21T14:53:45.677",
        "meterStatus": "NO"
    },
    {
        "sitename": "S9",
        "meterid": 62,
        "metername": "Coil Area Temperature 3\r\n",
        "rh": 41.4,
        "temperature": 28.7,
        "createdON": "2024-10-21T14:53:44.637",
        "meterStatus": "NO"
    },
    {
        "sitename": "S9",
        "meterid": 61,
        "metername": "Coil Area Temperature 2\r\n",
        "rh": 48.4,
        "temperature": 26.2,
        "createdON": "2024-10-21T14:53:43.607",
        "meterStatus": "NO"
    },
    {
        "sitename": "S9",
        "meterid": 60,
        "metername": "Coil Area Temperature 1\r\n",
        "rh": 40.5,
        "temperature": 29.7,
        "createdON": "2024-10-21T14:53:42.577",
        "meterStatus": "NO"
    },
    {
        "sitename": "S9",
        "meterid": 69,
        "metername": "Environmental Lab Temperature 1\r\n",
        "rh": 52.5,
        "temperature": 24.8,
        "createdON": "2024-10-17T01:23:03.767",
        "meterStatus": "OFF"
    }
]
  
  return (
    <div className="relative">
        <p className={` pb-2 text-xl ml-3 dark ${isdarkMode ? 'darkfont' : 'whitemode'} `}>METER STATUS</p>
  
  {/* {isLoading && (
    <div className="absolute inset-0 flex justify-center items-center bg-white dark:bg-gray-800 bg-opacity-10 dark:bg-opacity-10 z-50">
    
      <Spin size="large" />
    </div>
  )} */}

{loading  && (  
      <>
        <Skeleton active paragraph={{ rows: 6 }} />
      </> 
      )}


  <MeterGrid report={report} />
 
      <CustomDrawer
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
      >
        <div className="flex flex-col space-y-2">
          <CustomSelect
            label="Section:"
            options={flowSectionList}
            onSelect={handleChangeSection}
            valueKey="sectionID"
            nameKey="sectionName"
          />
          <small className="text-red-500 font-bold ml-[150px]">{sectionError}</small>
          <CustomSelect
            label="Converter / Group:"
            options={
              sectionId === 1 ? flowConverterList : flowGroupDetailList
            }
            onSelect={handleChangeConverterGroup}
            valueKey={sectionId === 1 ? "sitE_ID" : "groupID"}
            nameKey={sectionId === 1 ? "sitename" : "groupName"}
          />
          <small className="text-red-500 font-bold ml-[150px]">{converterError}</small>
          <SteamTreeSelectCustomWithSelectAll
            label="Meters:"
            data={
              sectionId === 1
                ? nsFlowConverterList
                : steamGroupMeterList
            }
            idKey={sectionId === 1 ? "meteR_METERID" : "meteR_METERID"}
            valueKey={sectionId === 1 ? "meteR_METERID" : "meteR_METERID"}
            nameKey={sectionId === 1 ? "metername" : "meterName"}
            selectedValues={selectedMeterIds}
            setSelectedValues={setSelectedMeterIds}
            onSelect={handleMeterChange}
          />
         
          <small className="text-red-500 font-bold ml-[150px]">{meterError}</small>

          
        </div>
        <div className="flex justify-center mt-4">
          <Button
            className="blue-btn"
            onClick={() => {
              handleSubmit();
            }}
          >
            Search
          </Button>
        </div>
      </CustomDrawer>
    </div>
  );
};

export default TempMeterStatus;
